import { Icon, Flex, Text } from '@/_components';
import { FC } from 'react';
import type { NotificationsEmptyProps } from './NotificationsEmpty.types';

export const NotificationsEmpty: FC<NotificationsEmptyProps> = () => {
  return (
    <Flex isColumn={true} isCentered={true} padding={10}>
      <Icon name="minus" color="secondary" size={20} />
      <Text type="small" color="secondary">
        No Notifications
      </Text>
    </Flex>
  );
};
